// extracted by mini-css-extract-plugin
export default {"root":"x7fQl5","top":"hK2sz6","bottom":"rJfkgs","tile":"HP7RQz"};